<app-navbar />
<main class="layout__content">
  <router-outlet />
</main>
